<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="'resetPassword'">
    <app-reset-password [oobCode]="oobCode"></app-reset-password>
  </ng-container>
  <ng-container *ngSwitchCase="'verifyEmail'">
    <app-email-verification [oobCode]="oobCode"></app-email-verification>
  </ng-container>
</ng-container>
